import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { $MAX_WIDTH } from '../Consts'
import brand from '../assets/brand.png'
import { getInitialLang } from '../Common'

export const $NAVBAR_HEIGHT = 60
const BP = 900
const hoverBg = 'rgba(255,255,255,0.12)'
const SHOW_INVESTOR = false

const investorLinksEN: [string, string][] = [
  ['/investor/demo', 'Demo Video'],
  ['/investor/pitch-deck', 'Pitch Deck'],
  ['/investor/business-plan', 'Business Plan'],
  ['/investor', 'Features'],
]

const investorLinksZH: [string, string][] = [
  ['/investor/demo', '演示视频'],
  ['/investor/pitch-deck', '融资路演资料'],
  ['/investor/business-plan', '商业计划书'],
  ['/investor', '产品特色'],
]
const EN = {
  home: 'Home',
  bookDemo: 'Book Demo',
  investor: 'Investor',
  contact: 'Contact',
  login: 'Login',
  investorLinks: investorLinksEN,
}

const ZH = {
  home: '首页',
  bookDemo: 'Book Demo',
  investor: '投资者',
  contact: '联系',
  login: '登录',
  investorLinks: investorLinksZH,
}
const LANGS = { en: EN, zh: ZH }

const Navbar: React.FC = () => {
  const [dropdown, setDropdown] = useState(false)
  const [menu, setMenu] = useState(false)
  const [mobile, setMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < BP
  )
  const [mobileInv, setMobileInv] = useState(false)
  const [lang] = useState<'en' | 'zh'>(getInitialLang)
  const t = LANGS[lang]
  const links = t.investorLinks

  const ref = useRef<HTMLLIElement>(null)
  const nav = useNavigate()
  const loc = useLocation()

  useEffect(() => {
    const onResize = () => {
      const m = window.innerWidth < BP
      setMobile(m)
      if (!m) {
        setMenu(false)
        setDropdown(false)
      }
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    const h = (e: MouseEvent) =>
      dropdown &&
      ref.current &&
      !ref.current.contains(e.target as Node) &&
      setDropdown(false)
    document.addEventListener('mousedown', h)
    return () => document.removeEventListener('mousedown', h)
  }, [dropdown])

  const active = (p: string) =>
    p === '/' ? loc.pathname === '/' : loc.pathname.startsWith(p)

  const linkBase: React.CSSProperties = {
    textDecoration: 'none',
    color: '#fff',
    padding: '0.1rem 0',
    borderBottom: '2px solid transparent',
    transition: 'border-color .25s',
    fontSize: '1.05rem',
  }

  const toggleMenu = () =>
    setMenu(o => {
      if (o) setMobileInv(false)
      return !o
    })

  return (
    <>
      <nav
        style={{
          height: $NAVBAR_HEIGHT,
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 1000,
          background:
            'linear-gradient(135deg, rgba(8,19,53,.85) 0%, rgba(4,9,30,.85) 100%)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <div
          style={{
            maxWidth: $MAX_WIDTH + 64,
            margin: '0 auto',
            padding: '0 2rem',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: '#fff',
            fontFamily:
              'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
          }}
        >
          <img
            src={brand}
            alt="BusinessA"
            style={{ height: 28, width: 'auto', cursor: 'pointer' }}
            onClick={() => nav('/')}
          />

          {!mobile && (
            <ul
              style={{
                listStyle: 'none',
                margin: 0,
                padding: 0,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <li>
                <Link
                  to="/"
                  style={{
                    ...linkBase,
                    marginRight: '2.5rem',
                    borderBottomColor: active('/') ? '#fff' : 'transparent',
                  }}
                >
                  {t.home}
                </Link>
              </li>
              <li>
                <Link
                  to="/book-demo"
                  style={{
                    ...linkBase,
                    marginRight: '2.5rem',
                    borderBottomColor: active('/book-demo')
                      ? '#fff'
                      : 'transparent',
                  }}
                >
                  {t.bookDemo}
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  style={{
                    ...linkBase,
                    marginRight: '1.5rem',
                    borderBottomColor: active('/contact')
                      ? '#fff'
                      : 'transparent',

                  }}
                >
                  {t.contact}
                </Link>
              </li>

              {SHOW_INVESTOR && (
              <li
                ref={ref}
                style={{ position: 'relative', cursor: 'pointer' }}
              >
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: '1.5rem',
                    gap: 4,
                    paddingLeft: '1.5rem',
                    borderLeft: '1px solid rgba(255,255,255,.35)',
                  }}
                  onClick={() => setDropdown(o => !o)}
                >
                  <span
                    style={{
                      ...linkBase,
                      borderBottomColor:
                        active('/investor') || dropdown
                          ? '#fff'
                          : 'transparent',
                    }}
                  >
                    {t.investor}
                  </span>
                  <svg
                    width={12}
                    height={8}
                    viewBox="0 0 12 8"
                    style={{
                      fill: 'currentColor',
                      transform: dropdown ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform .25s',
                    }}
                  >
                    <path d="M1 1l5 5 5-5" />
                  </svg>
                </span>

                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    left: '1.5rem',
                    background: '#0E162E',
                    borderRadius: 8,
                    overflow: 'hidden',
                    transform: dropdown
                      ? 'translateY(0)'
                      : 'translateY(-10px)',
                    opacity: dropdown ? 1 : 0,
                    transition: 'opacity .25s, transform .25s',
                    pointerEvents: dropdown ? 'auto' : 'none',
                    minWidth: 180,
                    filter: 'drop-shadow(0 10px 20px rgba(0,0,0,.6))',
                    zIndex: 3,
                  }}
                >
                  {links.map(([to, label]) => (
                    <Link
                      key={to}
                      to={to}
                      style={{
                        display: 'block',
                        padding: '0.75rem 1rem',
                        color: '#fff',
                        textDecoration: 'none',
                        fontSize: '.95rem',
                        transition: 'background .25s',
                      }}
                      onClick={() => setDropdown(false)}
                      onMouseEnter={e =>
                        (e.currentTarget.style.background = hoverBg)
                      }
                      onMouseLeave={e =>
                        (e.currentTarget.style.background = 'transparent')
                      }
                    >
                      {label}
                    </Link>
                  ))}
                </div>
              </li>
              )}

              <li>
                <Link
                  to="https://app.businessa.com"
                  target={'_blank'}
                  style={{
                    ...linkBase,
                    borderBottomColor: active('/login') ? '#fff' : 'transparent',
                    paddingLeft: '1.5rem',
                    borderLeft: '1px solid rgba(255,255,255,.35)',
                  }}
                >
                  {t.login}
                </Link>
              </li>
            </ul>
          )}

          {mobile && (
            <div
              style={{
                width: 28,
                height: 20,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              onClick={toggleMenu}
            >
              {['', '', ''].map((_, i) => (
                <span
                  key={i}
                  style={{
                    width: '100%',
                    height: 3,
                    background: '#fff',
                    borderRadius: 2,
                    transition: 'transform .25s, opacity .25s',
                    transform:
                      i === 0
                        ? menu
                          ? 'translateY(8.5px) rotate(45deg)'
                          : ''
                        : i === 2
                          ? menu
                            ? 'translateY(-8.5px) rotate(-45deg)'
                            : ''
                          : '',
                    opacity: i === 1 && menu ? 0 : 1,
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </nav>

      {mobile && (
        <div
          style={{
            position: 'fixed',
            top: $NAVBAR_HEIGHT,
            left: 0,
            width: '100%',
            background: '#0E162E',
            transformOrigin: 'top',
            transform: menu ? 'scaleY(1)' : 'scaleY(0)',
            transition: 'transform .25s',
            zIndex: 999,
          }}
        >
          <ul
            style={{
              listStyle: 'none',
              margin: 0,
              padding: '1.5rem 1.75rem',
              display: 'flex',
              flexDirection: 'column',
              gap: '.5rem',
            }}
          >
            <li>
              <Link
                to="/"
                style={{
                  ...linkBase,
                  display: 'block',
                  fontSize: '1.2rem',
                  borderBottom: 'none',
                  padding: '.9rem .6rem',
                  borderRadius: 8,
                }}
                onClick={() => setMenu(false)}
                onMouseEnter={e =>
                  (e.currentTarget.style.background = hoverBg)
                }
                onMouseLeave={e =>
                  (e.currentTarget.style.background = 'transparent')
                }
              >
                {t.home}
              </Link>
            </li>
            <li>
              <Link
                to="/book-demo"
                style={{
                  ...linkBase,
                  display: 'block',
                  fontSize: '1.2rem',
                  borderBottom: 'none',
                  padding: '.9rem .6rem',
                  borderRadius: 8,
                }}
                onClick={() => setMenu(false)}
                onMouseEnter={e =>
                  (e.currentTarget.style.background = hoverBg)
                }
                onMouseLeave={e =>
                  (e.currentTarget.style.background = 'transparent')
                }
              >
                {t.bookDemo}
              </Link>
            </li>

            <li>
              <Link
                to="/contact"
                style={{
                  ...linkBase,
                  display: 'block',
                  fontSize: '1.2rem',
                  borderBottom: 'none',
                  padding: '.9rem .6rem',
                  borderRadius: 8,
                }}
                onClick={() => setMenu(false)}
                onMouseEnter={e =>
                  (e.currentTarget.style.background = hoverBg)
                }
                onMouseLeave={e =>
                  (e.currentTarget.style.background = 'transparent')
                }
              >
                {t.contact}
              </Link>
            </li>

            {SHOW_INVESTOR && (
            <li>
              <span
                onClick={() => setMobileInv(o => !o)}
                style={{
                  ...linkBase,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '1.2rem',
                  padding: '.9rem .6rem',
                  borderRadius: 8,
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
                onMouseEnter={e =>
                  (e.currentTarget.style.background = hoverBg)
                }
                onMouseLeave={e =>
                  (e.currentTarget.style.background = 'transparent')
                }
              >
                {t.investor}
                <svg
                  width={12}
                  height={8}
                  viewBox="0 0 12 8"
                  style={{
                    fill: 'currentColor',
                    transform: mobileInv ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform .25s',
                  }}
                >
                  <path d="M1 1l5 5 5-5" />
                </svg>
              </span>
              <ul
                style={{
                  listStyle: 'none',
                  margin: 0,
                  padding: 0,
                  overflow: 'hidden',
                  maxHeight: mobileInv ? links.length * 48 : 0,
                  transition: 'max-height .25s',
                }}
              >
                {links.map(([to, label]) => (
                  <li key={to}>
                    <Link
                      to={to}
                      style={{
                        ...linkBase,
                        display: 'block',
                        fontSize: '1.05rem',
                        padding: '.65rem 1.6rem',
                        borderRadius: 6,
                      }}
                      onClick={() => {
                        setMenu(false)
                        setMobileInv(false)
                      }}
                      onMouseEnter={e =>
                        (e.currentTarget.style.background = hoverBg)
                      }
                      onMouseLeave={e =>
                        (e.currentTarget.style.background = 'transparent')
                      }
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            )}

            <li>
              <Link
                to="https://app.businessa.com"
                target={'_blank'}
                style={{
                  ...linkBase,
                  display: 'block',
                  fontSize: '1.2rem',
                  borderBottom: 'none',
                  padding: '.9rem .6rem',
                  borderRadius: 8,
                }}
                onClick={() => setMenu(false)}
                onMouseEnter={e => (e.currentTarget.style.background = hoverBg)}
                onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
              >
                {t.login}
              </Link>
            </li>
          </ul>
        </div>
      )}
    </>
  )
}

export default Navbar
